import { ReactComponent as DarkThemeIcon } from "../../../images/dark-mode.svg";
import { ReactComponent as LightThemeIcon } from "../../../images/light-mode.svg";

export default function LightDarkButton({ theme, setTheme }) {
  const isLightTheme = theme === "light";

  return (
    <div className={`theme-switcher ${!isLightTheme ? "theme-switcher--dark" : ""} flex-row`}>
      <button
        className="theme-switcher__button flex-row"
        onClick={() => setTheme(isLightTheme ? "dark" : "light")}
        type="button"
        aria-label={isLightTheme ? "Switch to dark theme" : "Switch to light theme"}
        aria-pressed={!isLightTheme}
      >
        {isLightTheme ? <LightThemeIcon className="theme-switcher__icon" /> : <DarkThemeIcon className="theme-switcher__icon" />}
      </button>
    </div>
  );
}
